import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { SubscriptionStore , MembershipStore } from '@seedlang/stores';
import InPlaceSelect from 'components/form/in_place_select';
import { sortBy } from 'lodash';
import Grid from 'components/layout/grid';
import ButtonPrimary from 'components/button/button_primary';

@observer
class SubscriptionCreate extends React.Component {
  @observable membershipId;
  @observable currency;
  @observable paymentMethod;

  constructor(props) {
    super(props);
    MembershipStore.getIndex({queryStrings: {expandMembership: true}, filters: {active: true}});
  }

  onClick() {
    if (this.currency && this.membershipId && this.paymentMethod) {
      SubscriptionStore.create(
        {
          data: {
            paymentMethod: this.paymentMethod,
            currency: this.currency,
            userId: this.props.userId,
            membershipId: this.membershipId,
            transactionId: this.refs.transactionId.value,
          },
        },
        this.props.afterCreate,
      );
      this.refs.transactionId.value = '';
    }
  }

  render() {
    return (
      <Grid columns={[2,1,2,4,3]}>
        <InPlaceSelect
          onChange={val => this.membershipId = val}
          includeBlank
          value={this.membershipId}
          options={sortBy(MembershipStore.indexData, ['title']).map(item => [item.id, `${item.title} (${item.numberMonths} months) - ${item.membershipGroupName}`])}
        />
        <InPlaceSelect
          onChange={val => this.currency = val}
          includeBlank
          value={this.currency}
          options={['USD', 'EUR']}
        />
        <InPlaceSelect
          onChange={val => this.paymentMethod = val}
          includeBlank
          value={this.paymentMethod}
          options={['paypal', 'stripe', 'ios', 'android']}
        />
        <input
          placeholder='Transaction Id'
          ref='transactionId'
        />
        <ButtonPrimary onClick={this.onClick.bind(this)}>
          Create
        </ButtonPrimary>
      </Grid>
    );
  }
}

export default SubscriptionCreate;
